import { render, staticRenderFns } from "./AccomodationTours.vue?vue&type=template&id=38059e91&scoped=true&"
import script from "./AccomodationTours.vue?vue&type=script&lang=js&"
export * from "./AccomodationTours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38059e91",
  null
  
)

export default component.exports